"use client";

import { usePathname } from "next/navigation";
import { EventsSearchBar } from "./search-bar";
import Image from "next/image";
import { useEffect, useState } from "react";

export function HeaderLayout() {
    const [theme, setTheme] = useState('light');

    useEffect(() => {
        // Periksa apakah sessionStorage memiliki nilai
        let sessionTheme = sessionStorage.getItem('theme');
        if (!sessionTheme) {
            // Jika sessionStorage kosong, gunakan nilai dari localStorage
            const storedTheme = localStorage.getItem('theme') || 'light';
            sessionStorage.setItem('theme', storedTheme);
            sessionTheme = storedTheme;
        }

        // Terapkan tema berdasarkan sessionStorage
        if (sessionTheme === 'dark') {
            document.documentElement.classList.add('dark');
            setTheme('dark');
        } else {
            document.documentElement.classList.remove('dark');
            setTheme('light');
        }
    }, []);

    const pathname = usePathname();
    if (
        pathname === '/events/all' ||
        pathname === '/events/featured' ||
        pathname === '/events/ongoing' ||
        pathname === '/events/past' ||
        pathname === '/events/upcoming' ||
        pathname === '/events/curated'
    ) {
        return (
            <>
                {/* <div className="fixed inset-x-0 top-0 w-full h-full -z-10">
                    <Image
                        src="/event-background.png"
                        className="object-cover w-full"
                        alt="pattern"
                        fill
                        style={{
                            objectFit: "cover",
                        }}
                    />
                </div> */}
                <>
                    <EventsSearchBar />
                    <div className="h-20 xl:h-32" />
                </>
            </>
        );
    }

    // Return null if the pathname doesn't match
    return null;
}
